import { useState, useEffect } from 'react';

/**
 * 防抖Hook
 * @param {any} value 需要防抖的值
 * @param {number} delay 延迟时间(ms)
 * @returns {any} 防抖后的值
 */
export default function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
